import React from 'react';
import { Badge } from '../../../ui/badge';
import { HeaderBlock as HeaderBlockType } from '../../../../types/report-builder';

interface Props {
  block: HeaderBlockType;
}

const HeaderBlock: React.FC<Props> = ({ block }) => {
  return (
    <div className="my-6 rounded-[28px] border border-border/70 bg-card px-6 py-5 shadow-[var(--shadow-card)]">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <Badge variant="secondary">Report header</Badge>
        <span className="text-[11px] font-medium uppercase tracking-[0.08em] text-muted-foreground">
          Generated overview
        </span>
      </div>
      <h1 className="font-jakarta text-2xl font-extrabold tracking-[-0.03em] text-foreground">
        {block.title}
      </h1>
      {block.subtitle && (
        <p className="mt-2 text-sm leading-[1.7] text-muted-foreground">{block.subtitle}</p>
      )}
      {block.timestamp && (
        <p className="mt-3 text-xs text-muted-foreground">{block.timestamp}</p>
      )}
    </div>
  );
};

export default HeaderBlock;
